import React from "react";

export default function MyStudents() {
  return <div>My students</div>;
}
